import { Navigate } from "@tanstack/react-router";
import type { ReactNode } from "react";
import type { AppRole } from "@msc/shared";
import { hasRole, useCurrentUser } from "../hooks/useAuth.js";

interface RequireRoleProps {
  roles: AppRole[];
  children: ReactNode;
}

/**
 * Generischer Rollen-Guard (Verallgemeinerung von RequireAdmin): Seiten, deren
 * Inhalte serverseitig ohnehin nur bestimmten Rollen antworten (Freigaben,
 * Einstellungen), sollen für alle anderen gar nicht erst erreichbar sein —
 * sonst entstehen „tote Türen" (leere Inbox, Formulare, die beim Speichern
 * mit 403 scheitern).
 */
export function RequireRole({ roles, children }: RequireRoleProps) {
  const { user, isLoading } = useCurrentUser();

  if (isLoading) {
    return null;
  }

  if (!hasRole(user, roles)) {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
}
